/* Batería Viva — interacciones (vanilla, sin librerías) */
(function () {
  if (window.__bvInit) return;
  window.__bvInit = true;
  document.documentElement.classList.add('bv-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esTactil = window.matchMedia('(hover: none)').matches;

  /* ---------- Reveals: un solo observer ---------- */
  var io = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.bv-reveal, .bv-cmp, .bv-pasos__linea');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('bv-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('bv-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('bv-visible')) io.observe(el); });
  }

  /* ---------- Héroe spotlight ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-bv-hero]').forEach(function (hero) {
      if (hero.dataset.bvInit) return; hero.dataset.bvInit = '1';
      if (reduce || esTactil) return;
      var raf = null;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        var x = ((ev.clientX - r.left) / r.width) * 100;
        var y = ((ev.clientY - r.top) / r.height) * 100;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          hero.style.setProperty('--bv-x', x.toFixed(1) + '%');
          hero.style.setProperty('--bv-y', y.toFixed(1) + '%');
        });
      });
      hero.addEventListener('pointerleave', function () {
        hero.style.removeProperty('--bv-x'); hero.style.removeProperty('--bv-y');
      });
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-bv-hs]').forEach(function (wrap) {
      if (wrap.dataset.bvInit) return; wrap.dataset.bvInit = '1';
      var puntos = wrap.querySelectorAll('.bv-hs__punto');
      var items = wrap.querySelectorAll('.bv-hs__item');
      var tip = wrap.querySelector('.bv-hs__tip');
      function activar(i, mostrarTip) {
        puntos.forEach(function (p, j) { p.classList.toggle('is-activo', j === i); });
        items.forEach(function (p, j) { p.classList.toggle('is-activo', j === i); });
        if (!tip) return;
        if (i < 0 || !mostrarTip) { tip.classList.remove('is-visible'); return; }
        var p = puntos[i];
        tip.querySelector('strong').textContent = p.dataset.titulo || '';
        tip.querySelector('p').textContent = p.dataset.texto || '';
        tip.style.left = p.style.left; tip.style.top = p.style.top;
        tip.classList.add('is-visible');
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { activar(i, true); });
        p.addEventListener('focus', function () { activar(i, true); });
        p.addEventListener('click', function () { activar(i, true); });
        p.addEventListener('mouseleave', function () { activar(i, false); });
        p.addEventListener('blur', function () { activar(-1, false); });
      });
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { activar(i, true); });
        it.addEventListener('mouseleave', function () { activar(-1, false); });
        it.addEventListener('click', function () { activar(i, true); });
      });
    });
  }

  /* ---------- Estimador de envío ---------- */
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function sumarHabiles(fecha, n) {
    var d = new Date(fecha.getTime());
    var sumados = 0;
    while (sumados < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) sumados++; }
    return d;
  }
  function fmt(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' ' + MESES[d.getMonth()]; }
  function initEnvio(root) {
    (root || document).querySelectorAll('[data-bv-env]').forEach(function (wrap) {
      if (wrap.dataset.bvInit) return; wrap.dataset.bvInit = '1';
      var sel = wrap.querySelector('select');
      var out = wrap.querySelector('.bv-env__fecha');
      var corte = parseInt(wrap.dataset.corte || '14', 10);
      function calc() {
        var o = sel.options[sel.selectedIndex];
        var min = parseInt(o.dataset.min || '1', 10), max = parseInt(o.dataset.max || '3', 10);
        var hoy = new Date();
        var base = hoy.getHours() >= corte ? sumarHabiles(hoy, 1) : hoy;
        var a = sumarHabiles(base, min), b = sumarHabiles(base, max);
        out.textContent = (min === max ? fmt(a) : fmt(a) + ' – ' + fmt(b));
      }
      sel.addEventListener('change', calc); calc();
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-bv-faq]').forEach(function (wrap) {
      if (wrap.dataset.bvInit) return; wrap.dataset.bvInit = '1';
      var solo = wrap.dataset.solo === 'true';
      wrap.querySelectorAll('.bv-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.bv-faq__item');
          var abrir = !item.classList.contains('is-abierto');
          if (solo) wrap.querySelectorAll('.bv-faq__item.is-abierto').forEach(function (o) {
            o.classList.remove('is-abierto'); o.querySelector('.bv-faq__q').setAttribute('aria-expanded', 'false');
          });
          item.classList.toggle('is-abierto', abrir);
          btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Producto: galería, variantes, cantidad, barra fija ---------- */
  function money(cents, formato) {
    var v = (cents / 100).toFixed(2);
    return (formato || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }
  function initProducto(root) {
    (root || document).querySelectorAll('[data-bv-pdp]').forEach(function (pdp) {
      if (pdp.dataset.bvInit) return; pdp.dataset.bvInit = '1';
      var main = pdp.querySelector('.bv-gal__main img');
      pdp.querySelectorAll('.bv-gal__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          pdp.querySelectorAll('.bv-gal__thumb').forEach(function (o) { o.classList.remove('is-activo'); });
          t.classList.add('is-activo');
          main.style.opacity = '0';
          setTimeout(function () { main.src = t.dataset.src; main.srcset = ''; main.style.opacity = '1'; }, 180);
        });
      });

      var qty = pdp.querySelector('.bv-buy__cantidad input');
      pdp.querySelectorAll('.bv-buy__cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value || '1', 10) + (b.dataset.paso === '+' ? 1 : -1);
          qty.value = Math.max(1, v);
        });
      });

      var json = pdp.querySelector('[data-bv-variantes]');
      if (json) {
        var variantes = JSON.parse(json.textContent);
        var formato = pdp.dataset.formato;
        var inputId = pdp.querySelector('input[name="id"]');
        var precio = pdp.querySelectorAll('[data-bv-precio]');
        var tachado = pdp.querySelector('[data-bv-tachado]');
        var boton = pdp.querySelector('[data-bv-boton]');
        var textoBoton = boton ? boton.dataset.texto : '';
        var textoAgotado = boton ? boton.dataset.agotado : '';
        pdp.querySelectorAll('[data-bv-opcion]').forEach(function (grupo) {
          grupo.addEventListener('change', function () {
            var elegidas = [];
            pdp.querySelectorAll('[data-bv-opcion]').forEach(function (g) {
              var c = g.querySelector('input:checked') || g.querySelector('select');
              elegidas.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) {
              return x.options.every(function (o, i) { return o === elegidas[i]; });
            });
            if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; } return; }
            inputId.value = v.id;
            precio.forEach(function (p) { p.textContent = money(v.price, formato); });
            if (tachado) {
              if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = money(v.compare_at_price, formato); tachado.hidden = false; }
              else tachado.hidden = true;
            }
            if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado; }
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      }

      var barra = document.querySelector('[data-bv-sticky]');
      var form = pdp.querySelector('.bv-buy form');
      if (barra && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          barra.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(form);
        var btnBarra = barra.querySelector('button');
        if (btnBarra) btnBarra.addEventListener('click', function () {
          var b = form.querySelector('[type="submit"]');
          if (b) b.click(); else form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.nodeType === 1 ? e.target : document;
    initReveals(root); initHero(root); initHotspots(root); initEnvio(root); initFaq(root); initProducto(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
